import { differenceInWeeks } from 'date-fns';

export function shouldOfferDeposit(startDate: Date | null): boolean {
  if (!startDate) {
    return false;
  }

  const now = new Date();
  const weeksFromNow = differenceInWeeks(startDate, now);

  return weeksFromNow >= 8;
}
